import { baseApi } from "@shared/api/baseApi";

interface FaceitLoginUrlResponse {
    url: string;
}

interface FaceitCallbackRequest {
    code: string;
    state: string;
}

interface FaceitCallbackResponse {
    success: boolean;
    message: string;
    faceitId: string;
    faceitNickname: string;
    accessToken: string;
    refreshToken: string;
    alreadyRegistered: boolean;
    alreadyTaken: boolean;
}

export const faceitLoginApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getFaceitLoginUrl: builder.mutation<FaceitLoginUrlResponse, void>({
            query: () => ({
                url: "auth/faceit-login-url",
                method: "POST",
            }),
        }),
        faceitCallback: builder.mutation<FaceitCallbackResponse, FaceitCallbackRequest>({
            query: (body) => ({
                url: "auth/faceit-callback",
                method: "POST",
                body,
            }),
        }),
    }),
});

export const { 
    useGetFaceitLoginUrlMutation,
    useFaceitCallbackMutation 
} = faceitLoginApi;
